export default "__VITE_ASSET__Cct1RIhk__"